/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const ItemBankWrapper = styled.div`
  background: inherit;
  &.lrn-assess {
    margin: 0;
    padding: 10px;
  }
  /* Common Rules */
  .lrn {
    font-family: 'MontserratRegular';
    color: #010101 !important;
    background: inherit;
  }

  .lrn_question {
    font-size: 1.3em;
    font-weight: bold;
    font-family: 'MontserratBold';
  }

  .lrn_response_input.lrn_incorrect:after,
  .lrn_response_container.lrn_correct:after,
  .lrn_response_container.lrn_incorrect:after,
  .lrn_response_input_wrapper.lrn_incorrect:after,
  .lrn_response_input_wrapper.lrn_correct:after,
  .lrn_mcq .lrn_mcqgroup.lrn_correct:after,
  .lrn_mcq .lrn_mcqgroup.lrn_incorrect:after,
  .lrn-response-validate-wrapper.lrn_correct:after,
  .lrn-response-validate-wrapper.lrn_incorrect:after {
    height: 2em !important;
    line-height: 2em !important;
    width: 2em !important;
    border-radius: 1.5em !important;
    margin-top: -0.3em;
  }

  /* Cloze Text */
  .lrn_clozetext .lrn_textinput:after {
    content: none !important;
    display: none !important;
  }

  .lrn_clozetext .lrn_textinput.lrn_correct input {
    border-style: solid !important;
    border-width: 0.1em 0.1em 0.1em 0.3em !important;
    border-color: #4a700a !important;
    background-color: transparent !important;
  }

  .lrn_clozetext .lrn_textinput.lrn_incorrect input,
  .lrn_clozetext .lrn_textinput.lrn_not_attempted input {
    border-style: solid !important;
    border-width: 0.1em 0.1em 0.1em 0.3em !important;
    border-color: #dd002f !important;
    background-color: transparent !important;
  }

  /* Cloze Association */
  .lrn_association .lrn_possibilityList .lrn_btn_drag .lrn_icon:before,
  .lrn_clozeassociation .lrn_possibilityList .lrn_btn_drag .lrn_icon:before,
  .lrn_imageclozeassociationV2 .lrn_possibilityList .lrn_btn_drag:before,
  .lrn_orderlist .lrn_item:before {
    content: '⠿' !important;
    top: 0 !important;
    font-size: 1.1em;
    color: #7a8599;
  }

  .lrn_sort_block .lrn_item > div {
    display: inline-block !important;
  }

  .lrn .lrn_possibilityListContainer.lrn_list_bottom:before,
  .lrn_clozeassociation span.lrn_correct:after,
  .lrn_clozeassociation span.lrn_incorrect:after,
  .lrn_tokenhighlight .lrn_tokenhighlight_highlight:after {
    content: none !important;
    display: none !important;
  }

  .lrn_clozeassociation .lrn_dropzone,
  .lrn_imageclozeassociationV2 .lrn_dropzone_mask {
    border-radius: 0.4em !important;
  }

  /* Image Cloze Text and Image Cloze Dropdown */
  .lrn_clozeassociation .lrn_incorrect .lrn_not_attempted_marker,
  .lrn_clozeassociation .lrn_correct .lrn_not_attempted_marker,
  .lrn_imageclozetext .lrn_textinput.lrn_not_attempted input,
  .lrn_imageclozedropdown .lrn_combobox span {
    background-color: #fbe3e3 !important;
  }

  .lrn_imageclozetext .lrn_cloze_response,
  .lrn_imageclozedropdown .lrn_combobox span {
    border: 1px solid #e5e5e5 !important;
    padding-left: 1em !important;
  }

  .lrn_imageclozetext .lrn_not_attempted:after,
  .lrn_imageclozedropdown .lrn_not_attempted:after {
    content: '' !important;
    color: #dd002f !important;
    position: absolute !important;
    top: 20% !important;
    right: 0.4em !important;
    font-family: LearnosityIconsRegular !important;
  }

  .lrn_imageclozedropdown .lrn_not_attempted:after {
    top: 5% !important;
  }

  .lrn-cloze-select::-webkit-scrollbar {
    width: 0.5em;
  }

  .lrn-cloze-select::-webkit-scrollbar-track {
    box-shadow: inset 0 0 2px grey;
    border-radius: 5px;
    background: #e5e5e5;
  }

  .lrn-cloze-select::-webkit-scrollbar-thumb {
    background: #ff9e16;
    border-radius: 5px;
  }

  .lrn_imageclozeassociationV2 .lrn_possibilityListContainer.lrn_list_bottom:before {
    content: none !important;
  }

  .lrn .lrn_possibilityList,
  .lrn .lrn_possibilityListContainer {
    background-color: transparent !important;
  }

  /* Check Button */
  button.lrn_validate {
    background-color: #ff9e16 !important;
    color: #fff !important;
    border-radius: 0.4em !important;
    padding: 0.2em 1.5em !important;
  }

  /* Text token highlight */
  .lrn_tokenhighlight .lrn_tokenhighlight_highlight {
    background-color: #fff8df !important;
  }

  .lrn_tokenhighlight .lrn_tokenhighlight_text .lrn_token.lrn_incorrect {
    background-color: #fbe3e3 !important;
    border-color: #dd002f !important;
  }

  .lrn_tokenhighlight .lrn_tokenhighlight_text .lrn_token.lrn_correct {
    background-color: #f0f8ed !important;
    border-color: #4a700a !important;
  }

  /* Text token highlight */
  .lrn_orderlist .lrn_sort_gripper {
    display: none !important;
  }

  .lrn_orderlist .lrn_item:before {
    margin-right: 1em;
  }

  .lrn_orderlist .lrn_sort_block {
    margin-bottom: 0 !important;
  }

  .lrn_association .lrn_assoc_question {
    border-radius: 0.4em;
  }

  .lrn_association .lrn_response .lrn_arrows .lrn_arrow {
    border-bottom: 0.2em solid #7a8599 !important;
  }

  .lrn_association .lrn_response .lrn_arrows .lrn_arrow:before,
  .lrn_association .lrn_response .lrn_arrows .lrn_arrow:after {
    top: -0.25em !important;
    border: 0.4em solid #7a8599 !important;
  }

  .lrn_association .lrn_dropzone {
    border-radius: 0.4em !important;
  }

  .lrn_association .lrn_dragdrop:not(.lrn_disabled).lrn_dropzone.lrn_highlight {
    border: 1px solid #ff9e16 !important;
    border-radius: 0.4em !important;
  }

  /* Multiple Choice Question */
  .lrn_mcq .lrn_response .lrn_mcqgroup-block .lrn-mcq-option.lrn_incorrect .lrn-label,
  .lrn_mcq .lrn_response .lrn_mcqgroup-block .lrn-mcq-option.lrn_correct .lrn-label {
    background-color: #fcfcd3 !important;
  }

  .lrn_mcq .lrn_mcqgroup-block .lrn_choiceLabel,
  .lrn_mcq .lrn_mcqgroup-block .lrn_choiceLabel {
    background-color: #fff !important;
  }

  .lrn_mcq .lrn-mcq-option.lrn_selected {
    border-color: transparent !important;
  }

  .lrn_mcq .lrn_mcqgroup-block .lrn-mcq-option.lrn_incorrect,
  .lrn_mcq .lrn_mcqgroup-block .lrn-mcq-option.lrn_correct {
    border-style: solid !important;
    border-width: 0.1em 0.1em 0.1em 0.3em !important;
    background-color: transparent !important;
  }

  .lrn_mcq .lrn_mcqgroup-block .lrn-mcq-option.lrn_incorrect {
    border-color: #dd002f !important;
  }

  .lrn_mcq .lrn_mcqgroup-block .lrn-mcq-option.lrn_correct {
    border-color: #4a700a !important;
  }

  .lrn_mcq .lrn-response-validate-wrapper {
    border-style: solid !important;
    border-width: 0.1em 0.1em 0.1em 0.3em !important;
    background-color: transparent !important;
  }

  .lrn_mcq .lrn_mcqgroup.lrn_mcqgroup-vertical .lrn-mcq-option {
    border: none !important;
  }

  .lrn_mcq .lrn_mcqgroup.lrn_mcqgroup-vertical .lrn-mcq-option.lrn_correct,
  .lrn_mcq .lrn_mcqgroup.lrn_mcqgroup-vertical .lrn-mcq-option.lrn_incorrect {
    background-color: #fff8df !important;
  }

  .lrn_imagecloze_container {
    min-height: 80px;
  }

  .lrn_distractor_rationale_content {
    margin: 1.42857em !important;
  }

  .lrn_validation_stem_numeration {
    display: none;
  }
  .lrn-group-bottom {
    position: sticky;
    bottom: 0;
    background-color: #fff;
    border-radius: 0.5rem;
  }
`;
